import { render, staticRenderFns } from "./ControlNumberCard.vue?vue&type=template&id=22028ec8"
import script from "./ControlNumberCard.vue?vue&type=script&lang=js"
export * from "./ControlNumberCard.vue?vue&type=script&lang=js"
import style0 from "./ControlNumberCard.vue?vue&type=style&index=0&id=22028ec8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports